import axios from "axios";

const KILL_SWITCH_REQUEST_TIMEOUT_MS = 10000;

export async function isKillSwitchEnabled(flagName) {
  try {
    const baseUrl = process.env.REACT_APP_JUSFY_FEATURE_FLAG_API_URL;
    const apiKey = process.env.REACT_APP_FEATURE_FLAG_API_KEY;

    const { data } = await axios.get(
      `${baseUrl}/unleash/is-enabled/${flagName}`,
      {
        headers: { "x-api-key": apiKey },
        timeout: KILL_SWITCH_REQUEST_TIMEOUT_MS,
      }
    );

    return data === true;
  } catch (error) {
    console.log("error ao buscar flags", error);
    return false;
  }
}
